import { PaycheckComplete } from "../paycheck/PaycheckComplete";
import { TotalArea } from "../totalArea/totalArea";

export const TwoCardsMarkup = ({block, textPaycheck, CustomBox, fullName, saveFullApartSquare}) => {
  return (
    <>
      <TotalArea totalArea={block.totalArea} CustomBox={CustomBox} fullName={fullName} saveFullApartSquare={saveFullApartSquare} />
      <PaycheckComplete text={textPaycheck} income={block.income} CustomBox={CustomBox} />
    </>
  );
};
